import { gql } from '@apollo/client'

export const GET_COUNTRIES = gql`
  query GetCountries {
    countries(pagination: { page: 0, size: 10000 }) {
      total
      items {
        id
        code
        name
      }
    }
  }
`

export const GET_CITY_SUGGESTIONS = gql`
  query GetCitySuggestions($input: CitySuggestionsInput!) {
    citySuggestions(input: $input) {
      total
      items {
        id
        name
        stateCode
        countryCode
      }
    }
  }
`

export const GET_CITY = gql`
  query GetCity($cityId: UUID!) {
    tcity(input: { id: $cityId }) {
      id
      param
      name
      stateCode
      tags
      timezone
      code
      countryCode
    }
  }
`
